/**
 * @generated SignedSource<<909de34645a7c0e83a1a6847ab552f78>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type EquipmentCategory = "AUDIO_VIDEO" | "BATTERY" | "CABLE" | "CAMERA" | "CAMERA_ACCESSORY" | "ETC" | "KIT" | "LENS" | "LIGHTING" | "MEDIA" | "NETWORK" | "POWER" | "PRINTER" | "SECURITY" | "WORKSTATION" | "WORKSTATION_ACCESSORY" | "%future added value";
export type BookPageCatalogQuery$variables = {
  category?: EquipmentCategory | null | undefined;
  endOn: any;
  startOn: any;
};
export type BookPageCatalogQuery$data = {
  readonly facebookLoginEnabled: boolean;
  readonly rentalItems: {
    readonly nodes: ReadonlyArray<{
      readonly assetTag: any;
      readonly available: boolean;
      readonly category: EquipmentCategory;
      readonly dailyRate: any | null | undefined;
      readonly description: string | null | undefined;
      readonly id: string;
      readonly image: any | null | undefined;
      readonly kitMembers: ReadonlyArray<{
        readonly id: string;
      }>;
      readonly name: string;
      readonly specifications: ReadonlyArray<string>;
    } | null | undefined> | null | undefined;
  };
  readonly viewer: {
    readonly id: string;
    readonly name: string | null | undefined;
  } | null | undefined;
};
export type BookPageCatalogQuery = {
  response: BookPageCatalogQuery$data;
  variables: BookPageCatalogQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "category"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endOn"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startOn"
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "category",
        "variableName": "category"
      },
      {
        "kind": "Literal",
        "name": "first",
        "value": 200
      }
    ],
    "concreteType": "AssetConnection",
    "kind": "LinkedField",
    "name": "rentalItems",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Asset",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "assetTag",
            "storageKey": null
          },
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "category",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "image",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "specifications",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dailyRate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Asset",
            "kind": "LinkedField",
            "name": "kitMembers",
            "plural": true,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": "available",
            "args": [
              {
                "kind": "Variable",
                "name": "endOn",
                "variableName": "endOn"
              },
              {
                "kind": "Variable",
                "name": "startOn",
                "variableName": "startOn"
              }
            ],
            "kind": "ScalarField",
            "name": "availableOn",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "User",
    "kind": "LinkedField",
    "name": "viewer",
    "plural": false,
    "selections": [
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "facebookLoginEnabled",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "BookPageCatalogQuery",
    "selections": (v5/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "BookPageCatalogQuery",
    "selections": (v5/*: any*/)
  },
  "params": {
    "cacheID": "837e081d5b1a0c229b8674e6486d9cee",
    "id": null,
    "metadata": {},
    "name": "BookPageCatalogQuery",
    "operationKind": "query",
    "text": "query BookPageCatalogQuery(\n  $startOn: ISO8601Date!\n  $endOn: ISO8601Date!\n  $category: EquipmentCategory\n) {\n  rentalItems(first: 200, category: $category) {\n    nodes {\n      id\n      assetTag\n      name\n      description\n      category\n      image\n      specifications\n      dailyRate\n      kitMembers {\n        id\n      }\n      available: availableOn(startOn: $startOn, endOn: $endOn)\n    }\n  }\n  viewer {\n    id\n    name\n  }\n  facebookLoginEnabled\n}\n"
  }
};
})();

(node as any).hash = "27cdd28687fac852a8e7d7dad42e6643";

export default node;
